<template>
  <div class="slide-content">
    <div class="resize-body">
      <div class="resize-content">
        <div class="title-content">
          <img src="../../../assets/image/kjqg/index/xskj/xskj-title.png" class="zcqd-title" alt="">
        </div>
        <div class="title-content">
          <img src="../../../assets/image/kjqg/index/xskj/xskj-subtitle.png" class="sub-title" alt="">
        </div>
        <div class="xskj-info">
          <div class="xskj-video swiper-no-swiping">
            <div class="video-con" v-html="videoHtml"></div>
            <div class="video-title">{{videoTitle}}</div>
          </div>
          <div class="xskj-swiper">
            <swiper ref="xskjSwiper" :options="xskjSwiper" v-if="xskjList.length > 0">
              <!-- <swiper ref="xskjSwiper" :options="xskjSwiper" v-if="xskjList.length > 0"> -->
              <swiperSlide v-for="(item,ind) in xskjList" :key="ind">
                <div class="item-cover" :style="{ backgroundImage: item.cover ? `url(${item.cover})` : '',}"></div>
              </swiperSlide>
            </swiper>
            <div class="swiper-button-next xskj"></div>
            <div class="swiper-button-prev xskj"></div>
          </div>
        </div>
        <div class="more" @click="toMoreList()">查看更多</div>
      </div>
    </div>

  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import services from "../../../assets/js/services";
import utils from "../../../assets/js/utils";
import { mapActions } from "vuex";
export default {
  props: ["scaling", "navActiveIndex"],
  mounted() {
    this.getxskjList()

  },
  components: {
    swiper, swiperSlide
  },
  data() {
    let self = this;
    return {
      specialId: services.KJQG_SPECIAL_ID,
      school_code: localStorage.getItem("schoolCode"),
      activeId: "",
      videoHtml: '',
      clickState: false,
      activePlaying: {},
      xskjSwiper: {
        direction: "vertical",
        slidesPerView: 4,
        spaceBetween: 12,
        slideActiveClass: 'active', // 活动块的className
        loop: true,
        loopAdditionalSlides: 0,
        slideToClickedSlide: true,
        autoplayDisableOnInteraction: false,
        autoplay: {
          delay: 5000,
          // pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.xskj`,
          prevEl: `.swiper-button-prev.xskj`,
        },
        on: {
          slideChange: function () {
            self.activeItem = self.xskjList[this.realIndex]
            self.$nextTick(() => {
              self.setVideo(self.activeItem)
            })

          },
          click: function () {
            self.clickState = true

          }
        },
      },
      xskjList: [],
      videoTitle: ""
    }
  },
  watch: {
    "clickState": {
      handler(newVal) {
        if (newVal && this.activePlaying) {
          this.activePlaying.play()
          this.$refs.xskjSwiper.swiper.autoplay.stop()
          this.clickState = false
        }

      },

    },
    navActiveIndex(newVal, oldVal) {
      if (this.xskjList.length) {
        if (newVal == 1) {
          this.$refs.xskjSwiper.swiper.autoplay.start()
        } else {
          this.$refs.xskjSwiper.swiper.autoplay.stop()
           this.activePlaying.pause()
        }

      }


    }
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin"]),
    async getxskjList() {
      let res = await services.getAreaSzztkLists({
        page: 1,
        length: 9,
        count: 0,
        school_code: this.school_code,
        special_id: this.specialId,
        kind: "1",
        is_video: 1,
        column_name: "习说科技",
        order_by: "asc"
      })
      if (res.code == "0000" && res.data.items) {
        this.xskjList = res.data.items
        this.$nextTick(() => {
          this.setVideo(this.xskjList[0])
        })
      }
    },
    setVideo(item) {
      this.videoTitle = item.title
      if (item.tencent_vod_file_id && item.tencent_vod_app_id) {
        let id = `v-${item.tencent_vod_file_id}${+ new Date()}`
        this.videoHtml = `<video id="${id}" :data-fileid="${item.tencent_vod_file_id}"
                :data-appid="${item.tencent_vod_app_id}" style="width: 100%;height: 100%"></video>`
        this.$nextTick(() => {
          this.initVideoFile(id, item.tencent_vod_file_id, item.tencent_vod_app_id)
        })
      } else {
        this.videoHtml = `<div class="img-cover" style="background-image: url('${item.cover}'); background-size: cover;background-position: center;width: 100%; height: 100%;"></div>`
      }
    },
    initVideoFile(elemId, qclude_id, appId) {
      utils.loadScript(
        window.location.origin + "/vod/hls.min.0.12.4.js",
        () => {
          utils.loadScript(
            window.location.origin + "/vod/tcplayer.min.js",
            () => {
              if (typeof window.TCPlayer === "function") {
                this.activePlaying = window.TCPlayer(elemId, {
                  // player-container-id 为播放器容器ID，必须与html中一致
                  fileID: qclude_id, // 请传入需要播放的视频filID 必须
                  // fileID: "5285890807937512700",
                  controls: true,
                  muted: true,
                  appID: appId, // 请传入点播账号的appID 必须
                  // width: utils.isMobile() ? 355 : 720, //视频的显示宽度
                  // height: utils.isMobile() ? 300 : 403, //视频的显示高度
                  definition: 30,
                  autoplay: false,

                  controlBar: {
                    progressControl: true
                  }
                });

                this.activePlaying.on("playing", () => {
                  this.$refs.xskjSwiper.swiper.autoplay.stop()
                })
                this.activePlaying.on("pause", () => {
                  this.$refs.xskjSwiper.swiper.autoplay.start()
                })

              }
            }
          );
        }
      );


    },
    toMoreList() {
      this.goAppsDetailsBeforeLogin().then(() => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/zcqdkc?ind=0`,
        });
        window.open(routeUrl.href, "_blank");
      });
    },
  },

}
</script>

<style lang="less" scoped>
.slide-content {
  padding-top: 5.16vw;
  background-size: cover;
  background-position: center;
  height: 100%;
  position: relative;
  .resize-body {
    position: relative;
    width: 100%;
    height: 100%;
    .resize-content {
      // height: 100%;
      // width: 1920px;
      // transform-origin: center center;
      // height: 981px;
      // position: absolute;
      // top: 50%;
      // left: 50%;
      // transform: translateX(-50%);
      .title-content {
        // margin: 0 auto;
        text-align: center;
        .zcqd-title {
          // max-width: 580px;
          max-height: 6.7vh;
          margin-top: 2.8vh;
        }
        .sub-title {
          // max-width: 812px;
          max-height: 4.9vh;
          margin-top: 1.6vh;
        }
      }
      .xskj-info {
        display: flex;
        justify-content: center;
        margin-top: 1.9vh;
        .xskj-video {
          width: 100.2vh;
          height: 62.3vh;
          background-image: url("../../../assets/image/kjqg/index/xskj/xskj-video-bg.png");
          background-size: 100% auto;
          background-position: center;
          // display: flex;
          // justify-content: center;
          padding-top: 4.6vh;
          .video-con {
            width: 89vh;
            height: 50vh;
            margin: 0 auto;
            .tcplayer {
              width: 100% !important;
              height: 100% !important;
            }
            video {
              width: 100%;
              height: 100%;
            }
            .img-cover {
              width: 100%;
              height: 100%;
              background-size: cover;
              background-position: center;
            }
          }
          .video-title {
            font-weight: bold;
            font-size: 1.5vh;
            color: #1f2734;
            text-align: center;
            margin-top: 1vh;
          }
        }

        .xskj-swiper {
          margin-left: 3.2vh;
          width: 26vh;
          height: 62.3vh;
          position: relative;
          padding: 3.7vh 1.9vh;
          overflow: hidden;
          .swiper-button-prev.xskj {
            width: 26vh;
            height: 2.6vh;
            background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-btn.png");
            background-size: 100% auto;
            top: 0;
            left: 0;
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            opacity: 1;
            &:hover {
              &::before {
                background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-icon-hover.png");
              }
            }
            &::before {
              content: "";
              display: block;
              width: 1.8vh;
              height: 1.2vh;
              background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-icon.png");
              background-size: cover;
            }
          }
          .swiper-button-next.xskj {
            width: 26vh;
            height: 2.6vh;
            background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-btn.png");
            background-size: 100% auto;
            bottom: 0;
            left: 0;
            top: unset;
            margin: 0;
            transform: rotate(180deg);
            display: flex;
            justify-content: center;
            align-items: center;
            opacity: 1;
            &:hover {
              &::before {
                background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-icon-hover.png");
              }
            }
            &::before {
              content: "";
              display: block;
              width: 1.8vh;
              height: 1.2vh;
              background-image: url("../../../assets/image/kjqg/index/xskj/xskj-swiper-icon.png");
              background-size: cover;
            }
          }
          .swiper-container {
            height: 100%;

            .swiper-slide {
              cursor: pointer;
              opacity: 0.7;
              &.active {
                border: 0.56vh solid;
                border-image: linear-gradient(45deg, #157bf9, #174bc9) 10 10;
                opacity: 1;
              }
              .item-cover {
                width: 100%;
                height: 100%;
                background-size: cover;
                background-position: center;
                background-image: url("../../../assets/image/kjqg/common/default-cover.png");
              }
            }
          }
        }
      }
      .more {
        width: 13.8vh;
        height: 4.3vh;
        line-height: 4.4vh;
        background-image: url("../../../assets/image/kjqg/index/xskj/more.png");
        background-size: cover;
        font-weight: 400;
        font-size: 1.5vh;
        color: #0c6aef;
        text-align: center;
        margin: 2.3vh auto 0;
        cursor: pointer;
      }
    }
  }
}
</style>